var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.dialog_delete,
            callback: function ($$v) {
              _vm.dialog_delete = $$v
            },
            expression: "dialog_delete",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Confirmar"),
              ]),
              _c("v-card-text", [
                _c("p", { staticClass: "mt-5 mb-0 fs-16 text-center" }, [
                  _vm._v(" " + _vm._s(_vm.text) + " "),
                ]),
                _vm.subtext
                  ? _c(
                      "p",
                      { staticClass: "mt-2 mb-0 fs-14 text-center grey--text" },
                      [_vm._v(" " + _vm._s(_vm.subtext) + " ")]
                    )
                  : _vm._e(),
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red darken-1", text: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("updateDialogDelete", false)
                        },
                      },
                    },
                    [_vm._v(" No ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("deleteItemConfirm")
                        },
                      },
                    },
                    [_vm._v(" Si ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }